module.exports = __webpack_public_path__ + "static/media/IOC_F1.e4384972.txt";